export default __webpack_public_path__ + "static/media/e-cert.3bffef02.svg";